import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const r = i((a, c) => /* @__PURE__ */ l.jsx(
  e,
  {
    ref: c,
    ...a,
    image: (s) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...s,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_6605_3118)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M38.948 40a.68.68 0 0 1-.681-.663l-.745-25.435c-.072-1.653-.962-3.033-2.488-3.878-1.453-.808-3.178-.88-4.749-.2a5.87 5.87 0 0 0-3.341 3.942l-1.935 7.79 2.852 11.542c.336 1.163.417 2.288.227 3.333-.418 2.27-1.79 3.568-3.778 3.568-1.135 0-2.116-.463-2.833-1.343-.944-1.172-1.317-3.024-.954-4.713l3.079-12.386-1.925-7.782a5.88 5.88 0 0 0-3.342-3.95c-1.562-.681-3.296-.609-4.75.2-.88.49-2.378 1.652-2.478 3.886l-.745 25.426a.686.686 0 0 1-.699.662A.675.675 0 0 1 9 39.3l.745-25.434c.09-2.134 1.253-3.96 3.187-5.031 1.825-1.017 3.996-1.108 5.957-.254a7.27 7.27 0 0 1 4.123 4.867l1.307 5.285 1.317-5.294a7.27 7.27 0 0 1 4.122-4.867c1.962-.854 4.132-.754 5.948.254 1.925 1.071 3.088 2.896 3.188 5.021l.744 25.453a.68.68 0 0 1-.663.7zM24.31 24.39l-2.452 9.861c-.272 1.263 0 2.697.69 3.55q.682.846 1.771.845c1.644 0 2.225-1.334 2.434-2.451.154-.836.081-1.753-.2-2.734z"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_6605_3118", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M9 8h30.629v32H9z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyMelasmaIcon";
export {
  r as AgencyMelasmaIcon,
  r as default
};
//# sourceMappingURL=index.js.map
